import React from "react";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";

const Feedback = ({
  duration = 6000,
  open = false,
  onClose = () => {},
  severity = "success",
  successText = "",
  errorText = "",
}) => {
  const message = severity === "error" ? errorText : successText;

  if (!severity) {
    // sometimes MUI throws an error if severity is not set, so we return null to avoid rendering the Snackbar at all
    return null;
  }

  return (
    <Snackbar
      open={!!open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      data-testid={`feedback-${severity}`}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Feedback;
